import * as types from './profile.actionTypes';

export const fetchProfileRequestActionCreator = () => {
  return { type: types.FETCH_PROFILE_REQUEST };
};

export const fetchProfileSuccessActionCreator = profile => {
  return { type: types.FETCH_PROFILE_SUCCESS, profile };
};

export const fetchProfileFailureActionCreator = error => {
  return { type: types.FETCH_PROFILE_FAILURE, error };
};

export const followProfileRequestActionCreator = () => {
  return { type: types.FOLLOW_PROFILE_REQUEST };
};

export const followProfileSuccessActionCreator = profile => {
  return { type: types.FOLLOW_PROFILE_SUCCESS, profile };
};

export const followProfileFailureActionCreator = error => {
  return { type: types.FOLLOW_PROFILE_FAILURE, error };
};

export const sendMessageRequestActionCreator = () => {
  return { type: types.SEND_MESSAGE_REQUEST };
};

export const sendMessageSuccessActionCreator = resp => {
  return { type: types.SEND_MESSAGE_SUCCESS, resp };
};

export const sendMessageFailureActionCreator = error => {
  return { type: types.FOLLOW_PROFILE_FAILURE, error };
};
